import { render } from "./SignupForm.vue?vue&type=template&id=76b7d80e&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=76b7d80e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b7d80e"]])

export default __exports__